import ExcelJS from "exceljs";

const resolve = (col, r) => (typeof col.value === "function" ? col.value(r) : r[col.value]);

// Export one or more styled sheets to a formatted .xlsx (vinotinto header, bold white, frozen row, autosized).
export async function exportXlsx(filename, sheets, meta = {}) {
  const wb = new ExcelJS.Workbook();
  wb.creator = "Always Fresh Music";
  wb.created = new Date();

  sheets.forEach(({ name, columns, rows }) => {
    const ws = wb.addWorksheet((name || "Hoja").slice(0, 31));
    ws.columns = columns.map((c) => ({
      header: c.label,
      key: c.label,
      width: Math.max(14, Math.min(42, String(c.label).length + 6)),
    }));
    rows.forEach((r) => ws.addRow(columns.map((c) => resolve(c, r))));

    const header = ws.getRow(1);
    header.height = 22;
    header.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11 };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF9E1B22" } };
      cell.alignment = { vertical: "middle", horizontal: "left" };
      cell.border = { bottom: { style: "thin", color: { argb: "FF7A1419" } } };
    });
    ws.eachRow((row, idx) => {
      if (idx === 1) return;
      if (idx % 2 === 0) row.eachCell((cell) => { cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFAF6F6" } }; });
    });
    ws.views = [{ state: "frozen", ySplit: 1 }];
  });

  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
